import { CreateArea } from "src/entity/company/areas.entity";
import http from "../utils/http-common";

export const getMaster = () => {
  return http.get(`/api/masterdata`);
};

export const createAreas = (body: { data: CreateArea[] }) => {
  return http.post(`/api/company/area`, body);
};

export const getAreaByCompany = (companyId: string) => {
  return http.get(`/api/company/area/${companyId}`);
};
